/// <amd-module name="Wit/DeliveryPlans/Common/Services/DeliveryPlansIterationService" />

import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IIteration } from "../Interfaces";

export interface IDeliveryPlansIterationService extends IVssService {
    getIteration(iterationPath: string): IIteration | undefined;
    getIterationById(iterationId: string): IIteration | undefined;
    addIteration(iteration: IIteration): void;
}

class DeliveryPlansIterationService extends VssService implements IDeliveryPlansIterationService {
    private _iterations: { [iterationPath: string]: IIteration } = {};
    private _iterationsById: { [iterationId: string]: IIteration } = {};
    public addIteration(iteration: IIteration): void {
        if (!this._iterations[iteration.path]) {
            this._iterations[iteration.path] = iteration;
        }

        if (!this._iterationsById[iteration.id]) {
            this._iterationsById[iteration.id] = iteration;
        }
    }

    public getIteration(iterationPath: string): IIteration | undefined {
        return this._iterations[iterationPath];
    }

    public getIterationById(iterationId: string): IIteration | undefined {
        return this._iterationsById[iterationId];
    }
}
Services.add("IDeliveryPlansIterationService", { serviceFactory: DeliveryPlansIterationService });
